import React, { Component } from 'react';
import logo from './logo.svg';
import './App.css';
import ValidatedFormComponent from "./components/ValidatedFormComponent";
import Form from "react-bootstrap/lib/Form";
import Col from "react-bootstrap/lib/Col";
import Button from "react-bootstrap/lib/Button";
import request from "request-promise-native";
import ProgressBar from "react-bootstrap/lib/ProgressBar";
import Alert from "react-bootstrap/lib/Alert";

import {StripeProvider, PaymentRequestButtonElement, injectStripe, Elements} from 'react-stripe-elements';
import Row from "react-bootstrap/es/Row";

const GET_PRICES = "https://ps1.qibipay.com/get_prices";
const BACKEND = "https://ps1.qibipay.com/checkout_start";

const GET_PRICES_MYPOS = "https://ps1.qibipay.com/mypos/get_prices";
const BACKEND_MYPOS = "https://ps1.qibipay.com/mypos/checkout_start";

function redirectPost(url, obj) {
    const form = document.createElement('form');
    document.body.appendChild(form);
    form.method = 'post';
    form.action = url;

    for (const name in obj) {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = name;
        input.value = decodeURIComponent(obj[name]);
        form.appendChild(input);
    }
    form.submit();
}

class App extends Component {
    constructor(props) {
        super(props);

        this.state = {
            amount: null,
            loading: false,
            submitting: false,
            invalidRegId: false,

            success: false,
            failed: false,
        };

        this.queryDict = {}
        window.location.search.substr(1).split("&").forEach(function(item) {
            this.queryDict[item.split("=")[0]] = item.split("=")[1]
        }.bind(this));

        if(this.queryDict["m"]==="1") {
            this.mypos = true;
        }

        if(this.queryDict['success']!=null ) {
            if(this.queryDict['success']==='true') {
                this.state.success = true;
                this.state.failed = false;
            }
            if(this.queryDict['success']==='false') {
                this.state.success = false;
                this.state.failed = true;
            }
            window.history.replaceState({}, document.title, "/");
            return;
        }

        if(this.queryDict['r']==null) {
            this.state.invalidRegId = true;
            window.history.replaceState({}, document.title, "/");
            return;
        }

        this.regId = this.queryDict['r'];

        if(this.queryDict['i']!=null) {
            this.itemNum = this.queryDict['i'];
            this.submit(this.regId, this.itemNum);
        } else {
            this.fetchPrices(this.regId);
        }

        window.history.replaceState({}, document.title, "/");

    }

    async fetchPrices(regId) {
        this.setState({
            loading: true,
            success: false,
            failed: false
        });

        const options = {
            method: 'POST',
            uri: this.mypos ? GET_PRICES_MYPOS : GET_PRICES,
            body: {
                regId
            },
            json: true,
            resolveWithFullResponse: true,
            simple: false
        };

        const response = await request(options);

        if(response.statusCode!==200) {
            this.setState({
                loading: false,
                failed: true,
                success: false
            });
            return;
        }

        this.setState({
            loading: false
        });

        this.setState({
            prices: response.body
        });

    }

    async submit(regId, itemNum) {

          this.setState({
              loading: true,
              success: false,
              failed: false
          });

          const options = {
              method: 'POST',
              uri: this.mypos ? BACKEND_MYPOS : BACKEND,
              body: {
                  regId,
                  itemNum
              },
              json: true,
              resolveWithFullResponse: true,
              simple: false
          };

          const response = await request(options);

          if(response.statusCode!==200) {
              this.setState({
                    loading: false,
                    failed: true,
                    success: false
              });
              return;
          }

          this.setState({
              loading: false,
              submitting: true
          });

          console.log("Response: ",response.body);

          if(this.mypos) {
              redirectPost(response.body.redirectUrl, response.body.redirectBody)
              return;
          }

          const stripe = window.Stripe(this.props.publicKey);

          stripe.redirectToCheckout({
              sessionId: response.body.sessionId
          }).then(function (result) {
              console.log("Result: "+result.error.message);
              // If `redirectToCheckout` fails due to a browser or network
              // error, display the localized error message to your customer
              // using `result.error.message`.
          });
    }

    render() {

        const buttons = [];

        if(this.state.prices!=null) {
            for(let key in this.state.prices) {
                buttons.push((
                    <>
                        <Row>
                            <Col xs={2}/>
                            <Col xs={8} componentClass={Button} className="btn-success" style={{
                                margin: "4px"
                            }} disabled={this.state.loading || this.state.submitting} onClick={() => {
                                this.submit(this.regId, this.state.prices[key].id)
                            }}>
                                {key}: {this.state.prices[key].price.toFixed(2)}€
                            </Col>
                            <Col xs={2}/>
                        </Row>
                    </>
                ))
            }
        }

        return (
                  <div className="content-div center">
                      <img className="logo" src="logo_qibixx_cmyk_trsp.png" alt="Qibixx" title="Qibixx"/>
                      {this.state.failed ? (<Alert bsStyle="danger">
                          <strong>Payment has failed!</strong>
                      </Alert>) : ""}
                      {this.state.invalidRegId ? (<Alert bsStyle="danger">
                          <strong>Invalid device ID!</strong>
                      </Alert>) : ""}
                      {this.state.success ? (<Alert bsStyle="success">
                          <strong>Payment was successful!</strong>
                      </Alert>) : (<Form horizontal>
                          {buttons}
                          {this.state.loading || this.state.submitting ? (
                              <div>
                                  <br/>
                                  <Col xs={1}/>
                                  <Col xs={10}>
                                      <ProgressBar bsStyle="success" active now={100}/>
                                  </Col>
                                  <Col xs={1}/>
                                  <br/>
                              </div>
                          ) : ""}
                      </Form>)}
                  </div>
        );
  }
}

export default App;
